import { Component, OnInit, ViewChild } from '@angular/core';
import { CoreService } from 'src/app/core/helpers/core.service';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from 'src/app/core/helpers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss']
})
export class RankingComponent implements OnInit {
  @ViewChild('deleteUser', { static: false }) deleteUserRef: any;
  @ViewChild('leaveTournament', { static: false }) leaveTournamentRef: any;
  @ViewChild('inviteUser', { static: false }) inviteUserRef: any;



  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  userId = '';
  selectedDate: any;
  public modalRef: BsModalRef;

  ranking: any;
  availableGamesRes: any;
  showRanking = 'CurrentWeek';
  showSurveyScript = false;
  rankingType = 0;

  firstRank = null;
  secondRank = null;
  thirdRank = null;
  tournamentId = '';
  deleteUserId = '';
  tournamentAdminId = '';
  tournamentName = '';
  link = '';
  inviteCode = '';
  chainName = '';
  logoUrl = '';
  isNickNameExist = false;
  weeklyRanking :any;
  isActive = true;

  constructor(private coreService: CoreService,
    private readonly toastr: ToastrService,
    private readonly translate: TranslateService,
    private modalService: BsModalService,

    private authService: AuthService,
    private datePipe: DatePipe,
    private gaService: GaService,
    private readonly toast: ToastrService,

    private router: Router,
    private cookie: CookieService, private loader: LoaderService) { }

  ngOnInit() {
    this.userId = this.authService.getUserId() ? this.authService.getUserId() : '';
    this.showSurvey();

    if (localStorage.getItem('tournamentAdminId')) {
      this.tournamentAdminId = localStorage.getItem('tournamentAdminId');
    }

    if (localStorage.getItem('isActive')) {
      this.isActive = JSON.parse(localStorage.getItem('isActive'));
    }

    if (localStorage.getItem('chain')) {
      let chain = localStorage.getItem('chain');
      if (chain !== '') {
        this.logoUrl = `https://assets.qnordicsgames.com/image/upload/q_auto/v1/NOSYNPRO25/chains/${chain}.png`;
      }
    }

    if (localStorage.getItem('nickNameExists')) {
      this.isNickNameExist = true;
    }

    if (localStorage.getItem('tournamentid')) {
      this.tournamentId = localStorage.getItem('tournamentid');
      this.inviteCode = localStorage.getItem('uniqueCode');
      this.link = 'https://' + window.location.host + '?id=' + this.tournamentId;
      this.getTournamentDetails();
    } else {
      this.getCombinedRanking(this.rankingType, '');
    }
    
  }

  showSurvey() {
    if (!localStorage.getItem('showSurvey') && this.userId !== '') {
      localStorage.setItem('showSurvey', 'showSurvey');
      this.cookie.delete('smcx_0_last_shown_at');
      this.showSurveyScript = true;
    }
  }

  copyCode(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.toast.success(this.translate.instant('copied'));
  }

  getRankingList() {
    // console.log('this.selectedDate', this.selectedDate);
    this.coreService.getRanking().then((res: any) => {
      this.ranking = res.rankingModel;

      if (this.ranking[0]) {
        this.firstRank = this.ranking[0]
      }

      if (this.ranking[1]) {
        this.secondRank = this.ranking[1]
      }

      if (this.ranking[2]) {
        this.thirdRank = this.ranking[2]
      }
    });
  }

  showWeeklyRank(week:string) {
    if (week === 'current') {
      this.ranking = this.weeklyRanking.currentWeek;
    } else {
      this.ranking = this.weeklyRanking.previousWeek;
    }

    if (this.ranking[0]) {
      this.firstRank = this.ranking[0]
    } else {
      this.firstRank = null;
    }

    if (this.ranking[1]) {
      this.secondRank = this.ranking[1]
    } else {
      this.secondRank = null;
    }

    if (this.ranking[2]) {
      this.thirdRank = this.ranking[2]
    } else {
      this.thirdRank = null;
    }
  }

  getCombinedRanking(rankingType:any, date:any) {
    this.chainName = localStorage.getItem('chain');
    this.coreService.getCombinedRanking(rankingType, date, this.chainName).then((response:any) => {
      if (this.rankingType === 0) {
        this.ranking = response.combinedRanking.daily;
      } else {
        this.weeklyRanking = response.combinedRanking;
        this.ranking = response.combinedRanking.currentWeek;
      }
      

      if (this.ranking[0]) {
        this.firstRank = this.ranking[0]
      } else {
        this.firstRank = null;
      }

      if (this.ranking[1]) {
        this.secondRank = this.ranking[1]
      } else {
        this.secondRank = null;
      }

      if (this.ranking[2]) {
        this.thirdRank = this.ranking[2]
      } else {
        this.thirdRank = null;
      }
    })
  }

  getTournamentDetails() {
    localStorage.removeItem('tournamentid');
    // console.log('this.selectedDate', this.selectedDate);
    this.coreService.getTournamentDetails(this.tournamentId).then((res: any) => {
      this.ranking = res.result.tournamentDetails;

      if (this.ranking[0]) {
        this.firstRank = this.ranking[0]
      }

      if (this.ranking[1]) {
        this.secondRank = this.ranking[1]
      }

      if (this.ranking[2]) {
        this.thirdRank = this.ranking[2]
      }
    });
  }

  remove(userId:string) {
    this.deleteUserId = userId;
    this.modalRef = this.modalService.show(this.deleteUserRef, this.popupConfig);

  }

  invite() {
    this.modalRef = this.modalService.show(this.inviteUserRef, this.popupConfig);
  }

  removeUser() {
    this.coreService.removeUser(this.deleteUserId, this.tournamentId).then((response:any) => {
      if (response.isSuccess) {
        this.toastr.success(this.translate.instant('user-deleted'), '');
      } else {
        this.toastr.error(this.translate.instant(response.messageKey), this.translate.instant('error'));
      }
      this.modalRef.hide();
      this.getTournamentDetails();
    })
  }


  getAvailableGames() {
    if (this.userId !== '') {
      this.coreService.getAvailableGames(this.userId).then((res: any) => {
        this.availableGamesRes = res.rankingModel;
      });
    }
  }

  redirectToUpload() {
    this.router.navigate(['receipt-upload']);
    return;

  }

  onPlayClick() {
    let url = localStorage.getItem('gameurl');
    window.open(url, '_self');
  }

  play() {
    if (this.isNickNameExist) {
      this.gaService.emitEvent('gameplays', 'Register Screen');
      if (this.tournamentId != '') {
        this.coreService.play(this.userId, this.inviteCode).then((response:any) => {
          window.open(response.result.gameurl, '_self')
        })
      } else {
        let url = localStorage.getItem('gameurl');
        window.open(url, '_self');
      }
      
    } else {
      this.toastr.error(this.translate.instant('nickname-not-set'), '');
    }
  }

  close() {
    this.modalRef.hide();
  }

  createTournament() {
    this.router.navigate(['/create-tournament']);
  }

  leaveTournamentUser() {
    this.coreService.leaveTournament(this.tournamentId).then((response) => {
      this.modalRef.hide();
      this.toastr.success(this.translate.instant('left-tournament'), '');
      this.router.navigate(['/tournament-list'])
    })
  }

  leave() {
    this.modalRef = this.modalService.show(this.leaveTournamentRef, this.popupConfig);

  }

  goToTournamentList() {
    this.router.navigate(['/tournament-list']);
  }

  onDateSelection($event) {
    const date = this.selectedDate ? this.datePipe.transform(this.selectedDate, 'dd.MM.yyyy') : undefined;
    this.getCombinedRanking(0, date);
  }

  onTodayClick() {
    this.selectedDate = '';
    this.getCombinedRanking(0, '');
  }

  ngOnDestroy() {
    if (localStorage.getItem('tournamentName')) {
      localStorage.removeItem('tournamentName');
      localStorage.removeItem('uniqueCode');
      localStorage.removeItem('isActive');
    }
  }

}
